export default "__VITE_ASSET__zCQEjhaZ__"